import { render, staticRenderFns } from "./InstagramContactListSwitcher.vue?vue&type=template&id=495cefbf"
import script from "./InstagramContactListSwitcher.vue?vue&type=script&lang=js"
export * from "./InstagramContactListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./InstagramContactListSwitcher.vue?vue&type=style&index=0&id=495cefbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports